import {Formik} from "formik";
import {Button, Modal} from "react-bootstrap";
import * as Yup from "yup";
import {useGetCatgeory} from "../../../hooks/useCategory";
import {useState} from "react";
import SubCategoryDrop from "../Profile/SubCategory";

const AnnonceModal = ({addAnnonce, setAddAnnonce}) => {
  const [selectedCat, setSelectedCat] = useState([]);
  const [subCatIds, setSubCatIds] = useState(new Set([]));

  const {data: categories, isLoading: isLoadingCategory} = useGetCatgeory();
  const handleSelect = (e) => {
    let categoryObject = categories.find((ele) => ele.id == e.target.value);

    if (categoryObject)
      setSelectedCat((prev) => {
        let set = new Set([...prev, categoryObject]);
        return Array.from(set.values());
      });
  };

  const formSchema = Yup.object().shape({
    title: Yup.string()
      .required("Title is required")
      .min(2, "Title must be at least 2 characters long"),

    description: Yup.string()
      .required("Description is required")
      .min(2, "Description must be at least 2 characters long"),

    address: Yup.string()
      .required("Address is required")
      .min(5, "Address must be at least 5 characters long"),

    ville: Yup.string()
      .required("Ville is required")
      .min(2, "Ville must be at least 2 characters long"),

    postCode: Yup.string()
      .required("Post code is required")
      .matches(/^\d{5}$/, "Post code must be exactly 5 digits"),

    minBudget: Yup.number()
      .required("Minimum budget is required")
      .positive("Minimum budget must be a positive number")
      .min(1, "Minimum budget must be at least 1 euro")
      .max(
        Yup.ref("maxBudget"),
        "Minimum budget must be less than or equal to maximum budget"
      ),

    maxBudget: Yup.number()
      .required("Maximum budget is required")
      .positive("Maximum budget must be a positive number")
      .min(
        Yup.ref("minBudget"),
        "Maximum budget must be greater than or equal to minimum budget"
      ),
  });
  return (
    <Modal
      className="modal fade "
      show={addAnnonce}
      onHide={setAddAnnonce}
      centered
      size="lg"
    >
      <div className="modal-content ">
        <div className="modal-header">
          <h4 className="modal-title ">Créer une annonce</h4>
          <Button
            variant=""
            type="button"
            className="close"
            onClick={() => setAddAnnonce(false)}
          >
            <span>×</span>
          </Button>
        </div>
        <div className="modal-body h-[70vh] overflow-scroll overflow-style-none">
          <Formik
            initialValues={{
              title: "",
              description: "",
              address: "",
              ville: "",
              postCode: "",
              minBudget: "",
              maxBudget: "",
            }}
            validationSchema={formSchema}
            onSubmit={(values, {setSubmitting}) => {
              const {currentPassword, newPassword} = values;

              setSubmitting(false);
            }}
          >
            {({
              values,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <form onSubmit={handleSubmit}>
                <h3 className="text-center  font-semibold   leading-3">
                  Remplir les données
                </h3>

                {/*  {props.errorMessage && (
                        <div className="bg-red-300 text-red-900 border border-red-900 p-1 my-2">
                          {props.errorMessage}
                        </div>
                      )}
                      {props.successMessage && (
                        <div className="bg-green-300 text-green-900 border border-green-900 p-1 my-2">
                          {props.successMessage}
                        </div>
                      )} */}
                <div className="w-full p-2 flex flex-col justify-center">
                  <div className="form-group">
                    <label className=" text-base font-medium leading-3 text-[#7E7E7E]">
                      Titre de l'annonce
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      aria-required="true"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.title}
                    />
                    {errors.title && (
                      <div
                        className="invalid-feedback animated fadeInUp"
                        style={{display: "block"}}
                      >
                        {errors.title}
                      </div>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="text-base font-medium leading-3 text-[#7E7E7E]">
                      Description
                    </label>
                    <textarea
                      rows={3}
                      type="text"
                      className="form-control"
                      name="description"
                      aria-required="true"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.description}
                    />
                    {errors.description && (
                      <div
                        className="invalid-feedback animated fadeInUp"
                        style={{display: "block"}}
                      >
                        {errors.description}
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="required-field-label text-base font-medium leading-3 text-[#7E7E7E]">
                      Sous-Catégorie
                    </label>
                    <select className="form-control " onChange={handleSelect}>
                      <option value="" disabled selected hidden>
                        Choisir vos spécialités
                      </option>
                      {categories?.map((category) => (
                        <option value={category.id}>{category.title}</option>
                      ))}
                    </select>

                    {!!selectedCat.length && (
                      <div className="flex flex-wrap justify-start items-start gap-4 w-full mt-2">
                        {selectedCat.map((category) => (
                          <div className="w-1/2 xl:w-1/3 truncate">
                            <SubCategoryDrop
                              category={category}
                              subCatIds={Array.from(subCatIds.values())}
                              setSubCatIds={setSubCatIds}
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="text-base font-medium leading-3 text-[#7E7E7E]">
                      Adresse
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="address"
                      aria-required="true"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.address}
                    />
                    {errors.address && (
                      <div
                        className="invalid-feedback animated fadeInUp"
                        style={{display: "block"}}
                      >
                        {errors.address}
                      </div>
                    )}
                  </div>
                  <div className="flex w-full gap-2">
                    <div className="form-group w-1/2">
                      <label className="text-base font-medium leading-3 text-[#7E7E7E]">
                        Ville
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="ville"
                        aria-required="true"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.ville}
                      />
                      {errors.ville && (
                        <div
                          className="invalid-feedback animated fadeInUp"
                          style={{display: "block"}}
                        >
                          {errors.ville}
                        </div>
                      )}
                    </div>
                    <div className="form-group w-1/2">
                      <label className="text-base font-medium leading-3 text-[#7E7E7E]">
                        Code Postal
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="postCode"
                        aria-required="true"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.postCode}
                      />
                      {errors.postCode && (
                        <div
                          className="invalid-feedback animated fadeInUp"
                          style={{display: "block"}}
                        >
                          {errors.postCode}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="flex w-full gap-2">
                    <div className="form-group w-1/2">
                      <label className="text-base font-medium leading-3 text-[#7E7E7E]">
                        Budget Minimum
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="minBudget"
                        min="1"
                        aria-required="true"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.minBudget}
                      />
                      {errors.minBudget && (
                        <div
                          className="invalid-feedback animated fadeInUp"
                          style={{display: "block"}}
                        >
                          {errors.minBudget}
                        </div>
                      )}
                    </div>

                    <div className="form-group w-1/2">
                      <label className="text-base font-medium leading-3 text-[#7E7E7E]">
                        Budget Maximum
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="maxBudget"
                        min="1"
                        aria-required="true"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.maxBudget}
                      />
                      {errors.maxBudget && (
                        <div
                          className="invalid-feedback animated fadeInUp"
                          style={{display: "block"}}
                        >
                          {errors.maxBudget}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <button
                      disabled={isSubmitting}
                      type="submit"
                      className="btn text-white hover:!bg-[#1a71b9] !bg-[#1A64B9] !border-[#1A64B9] btn-block uppercase"
                    >
                      Publier
                    </button>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </Modal>
  );
};
export default AnnonceModal;
